<div class="modal-overlay" *ngIf="show">
  <div class="modal-content">
    <div class="modal-header">
      <div class="header-main">
        <div class="header-icon-container">
          <fa-icon [icon]="faRocket"></fa-icon>
        </div>
        <div class="header-titles">
          <h3>{{ 'KNOWLEDGE_BASE.DEPLOY.TITLE' | translate }}</h3>
          <p>{{ archive?.name }}</p>
        </div>
      </div>
      <button class="close-btn" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">
      <div class="options-grid">
        <div class="options-section">
          <div class="section-header">
            <span class="section-title">{{ 'KNOWLEDGE_BASE.DEPLOY.SECTION' | translate }}</span>
          </div>

          <div class="config-field">
            <label>{{ 'KNOWLEDGE_BASE.NAME' | translate }}</label>
            <input type="text" class="form-input" [(ngModel)]="name"
              [placeholder]="'KNOWLEDGE_BASE.NAME_PLACEHOLDER' | translate">
          </div>

          <div class="config-field">
            <label>{{ 'KNOWLEDGE_BASE.SPLIT_METHOD' | translate }}</label>
            <select class="form-select" [(ngModel)]="splitMethod">
              @for (method of splitMethods; track method) {
                <option [value]="method">{{ 'KNOWLEDGE_BASE.SPLIT.' + method | translate }}</option>
              }
            </select>
          </div>

          @if (splitMethod === 'regex') {
            <div class="config-field">
              <label>{{ 'KNOWLEDGE_BASE.REGEX_PATTERN' | translate }}</label>
              <input type="text" class="form-input" [(ngModel)]="regexPattern"
                [placeholder]="'KNOWLEDGE_BASE.REGEX_PLACEHOLDER' | translate">
              <span class="field-hint">{{ 'KNOWLEDGE_BASE.REGEX_HINT' | translate }}</span>
            </div>
          }

          <div class="config-field">
            <label>{{ 'KNOWLEDGE_BASE.CONTAINER_NAME' | translate }}</label>
            <input type="text" class="form-input" [(ngModel)]="containerName"
              [placeholder]="'KNOWLEDGE_BASE.CONTAINER_NAME_PLACEHOLDER' | translate">
          </div>

          @if (delfosServerConfigs.length > 1) {
            <div class="config-field">
              <label>{{ 'KNOWLEDGE_BASE.DELFOS_SERVER' | translate }}</label>
              <ng-select
                [items]="delfosServerConfigs"
                bindLabel="display_label"
                bindValue="id"
                [(ngModel)]="selectedDelfosServer"
                [placeholder]="'INTERACTIONS.CONFIG.SELECT_OPTION' | translate"
                [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                [clearable]="true"
                [searchable]="false">
              </ng-select>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <app-button [text]="'BUTTON.CANCEL' | translate" variant="secondary" (clicked)="onClose()">
      </app-button>
      <app-button [text]="'BUTTON.DEPLOY' | translate" variant="primary" [icon]="faRocket" [loading]="loading"
        [disabled]="!canDeploy" (clicked)="onDeploy()">
      </app-button>
    </div>
  </div>
</div>
